export const initialState = {
  movieReviewsList: []
};
